import { render, staticRenderFns } from "./SignupConsent.vue?vue&type=template&id=c7d9c234&scoped=true&"
import script from "./SignupConsent.vue?vue&type=script&lang=js&"
export * from "./SignupConsent.vue?vue&type=script&lang=js&"
import style0 from "./SignupConsent.vue?vue&type=style&index=0&id=c7d9c234&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d9c234",
  null
  
)

export default component.exports